"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";

interface NavItemProps {
  children: React.ReactNode;
  title: string;
  href: string;
  onClick?: () => void;
}

export function NavItem({ children, href, title, onClick }: NavItemProps) {
  const pathname = usePathname();
  const isActive = pathname === href;

  return (
    <Link
      onClick={onClick}
      href={href}
      className={`flex items-center h-6 gap-6 pl-10 text-white border-l-2 border-transparent ${isActive && "border-white"}`}>
      {children}
      <span className="font-light text-md">{title}</span>
    </Link>
  );
}
